// extracted by mini-css-extract-plugin
export default {"threadsWrapper":"PrivateGroups_threadsWrapper__PnzgZ","search":"PrivateGroups_search__bihZy","toggleButton":"PrivateGroups_toggleButton__Xhm2T","error":"PrivateGroups_error__9t70U"};